import { Route, Routes } from 'react-router-dom';

import { WebPageType } from '../constants/webPageType';
import EntryScreen from '../screens/Auth/Entry';
import ForgotPasswordScreen from '../screens/Auth/ForgotPassword';
import LoginScreen from '../screens/Auth/Login';
import RegisterScreen from '../screens/Auth/Register';
import ResetPasswordScreen from '../screens/Auth/ResetPassword';
import SuccessRegScreen from '../screens/Auth/SuccessReg';
import WEAHomeScreen from '../screens/WEA/WEAHomeScreen';
import { WEANotFound } from '../screens/WEA/WEANotFound';
import WEATeacherMembershipProgramDetailsScreen from '../screens/WEA/WEAProgramDetailScreen';
import WEAProgramRedemptionScreen from '../screens/WEA/WEAProgramRedemption';
import WEAReferralRewardDetailsScreen from '../screens/WEA/WEAReferralRewardDetailsScreen';
import WEATeacherReferralOverviewScreen from '../screens/WEA/WEATeacherReferralOverviewScreen';

import AccountRoute from './AccountRoute';

const WEARoute: React.FC = () => {
  const isDevEnvOnly = process.env.NODE_ENV === 'development';
  return (
    <Routes>
      <Route path="/" element={<WEATeacherMembershipProgramDetailsScreen />} />
      {isDevEnvOnly && <Route path="/home" element={<WEAHomeScreen />} />}
      <Route
        path="/start"
        element={<EntryScreen webPageType={WebPageType.WEA} />}
      />
      <Route
        path="/login"
        element={<LoginScreen webPageType={WebPageType.WEA} />}
      />
      <Route
        path="/forgot-password"
        element={<ForgotPasswordScreen webPageType={WebPageType.WEA} />}
      />
      <Route
        path="/register"
        element={
          <RegisterScreen webPageType={WebPageType.WEA} isPhoneSignup={true} />
        }
      />
      <Route
        path="/register/success"
        element={<SuccessRegScreen webPageType={WebPageType.WEA} />}
      />
      <Route
        path="/referral-detail"
        element={<WEAReferralRewardDetailsScreen />}
      />
      <Route path="/referral" element={<WEATeacherReferralOverviewScreen />} />
      <Route
        path="/rewardRedemption/:id"
        element={<WEAProgramRedemptionScreen />}
      />
      <Route
        path="/settings/*"
        element={<AccountRoute webPageType={WebPageType.WEA} />}
      />
      <Route
        path="/reset-password"
        element={<ResetPasswordScreen webPageType={WebPageType.WEA} />}
      />
      <Route path="*" element={<WEANotFound />} />
    </Routes>
  );
};

export default WEARoute;
